import React, { useCallback, useState } from "react";

import Drawer from "veneer/Drawer";

import { createContentGroupAction } from "cortex/ui/src/fleet/redux-store/content-groups/actions";
import ContentGroupCreateForm from "cortex/ui/src/fleet/view/media-library/component/ContentGroupCreateForm";
import { ContentGroupItem } from "cortex/ui/src/fleet/view/media-library/model";
import { useAppDispatch, useAppSelector } from "cortex/ui/src/hooks";
import { addErrorMessageAction } from "cortex/ui/src/redux-store/messages/actions";
import {
  filterByProperty,
  makeGetAllAsArray,
} from "cortex/ui/src/redux-store/selectors";
import { userContentsSelector } from "cortex/ui/src/redux-store/user-contents/selectors";

const getAllUserContentsAsArray = makeGetAllAsArray<ContentGroupItem>();

interface ContentGroupDrawerProps {
  open: boolean;
  onCancel: () => void;
}

export default function ContentGroupDrawer({
  open,
  onCancel,
}: ContentGroupDrawerProps) {
  const dispatch = useAppDispatch();
  const userContentsById = useAppSelector(userContentsSelector);
  const userContents = getAllUserContentsAsArray(
    filterByProperty(userContentsById, "archived", false),
  );
  const [contentGroupName, setContentGroupName] = useState<string>("");
  const [contentGroupItems, setContentGroupItems] = useState<
    ReadonlyArray<ContentGroupItem>
  >([]);

  const handleCancel = useCallback(() => {
    setContentGroupName("");
    setContentGroupItems([]);
    onCancel();
  }, [onCancel]);

  const handleCreateContentGroup = useCallback(async () => {
    if (!contentGroupName || contentGroupItems.length === 0) {
      dispatch(
        addErrorMessageAction(
          "Content group name and items are required to create a content group",
        ),
      );
      return;
    }
    try {
      await dispatch(
        createContentGroupAction(
          { content: contentGroupItems, name: contentGroupName },
          "Content Group created!",
        ),
      );
      handleCancel();
    } catch (_err) {
      dispatch(addErrorMessageAction("Failed to create content group"));
    }
  }, [contentGroupName, contentGroupItems, dispatch, handleCancel]);

  return (
    <Drawer
      commitDisabled={contentGroupItems.length === 0 || !contentGroupName}
      onCancel={onCancel}
      onClose={handleCancel}
      onCommit={handleCreateContentGroup}
      open={open}
      size="large"
      title="Add Media Group"
    >
      <ContentGroupCreateForm
        contentGroupName={contentGroupName}
        onChangeName={setContentGroupName}
        onUpdateContent={setContentGroupItems}
        selectedContent={contentGroupItems}
        userContents={userContents}
      />
    </Drawer>
  );
}
